import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ExportService} from '../commons/services/export/export.service';

@Component({
  selector: 'luci-tool-bar',
  templateUrl: './luci-toolbar.component.html',
  styleUrls: ['./luci-toolbar.component.scss']
})
export class LuciToolbarComponent implements OnInit {

  searchQuery = '';
  @Input() isSearchRight = false;
  @Input() isExport = false;
  @Input() isSearch = false;
  @Input() exportTypes = ['excel'];
  @Input() fileName = '';
  @Input() tableHeaders = [];
  @Input() tableData  = [];
  @Input() cstSeparator = ',';
  @Input() pdfType = '';
  @Input() customExportIcon = false;
  @Input() isHideColumns = false;
  @Input() isMultiColumnSorting = false;
  @Input() isSearchable = false;
  @Input() isRefresh = false;
  @Input() placeHolder = 'Search';
  @Input() restoreIcon = '';
  @Input() filterIcon = '';
  @Input() hideColumnsIcon = '';
  @Input() sortColumnsIcon = '';
  @Input() isSelect = false;
  @Input() dropDownOptions = [];
  @Input() selectedOption = '';
  @Output() updateSearchQuery = new EventEmitter();
  @Output() updateExport =  new EventEmitter();
  @Output() isRefreshCallBack = new EventEmitter();
  @Output() isSearchableCallback = new EventEmitter();
  @Output() isHideShowColumnsCallBack = new EventEmitter();
  @Output() isMultiColumnSortingCallBack = new EventEmitter();
  @Output() emitSelectedItem = new EventEmitter();
  

  constructor(private exportService: ExportService) { }

  ngOnInit(): void {
  }

  export(type){
    if (type === 'excel') {
      this.exportService.exportAsExcelFile(this.tableData, this.fileName);
    } else if (type === 'csv') {
      this.exportService.exportCSV(this.tableHeaders, this.tableData, this.fileName, this.cstSeparator);
    } else if (type === 'pdf') {
      this.exportService.exportAsPDF(this.fileName, this.tableData, this.pdfType,  this.tableHeaders);
    } else {
      // todo
    }
    this.updateExport.emit();
  }

}
